/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Pending_TitleInputs */

const en_directory_submit_review_pending_title = /** @type {(inputs: Directory_Submit_Review_Pending_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted — awaiting review`)
};

const zh_directory_submit_review_pending_title = /** @type {(inputs: Directory_Submit_Review_Pending_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已提交 — 等待审核`)
};

/**
* | output |
* | --- |
* | "Submitted — awaiting review" |
*
* @param {Directory_Submit_Review_Pending_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_pending_title = /** @type {((inputs?: Directory_Submit_Review_Pending_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Pending_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_pending_title(inputs)
	return zh_directory_submit_review_pending_title(inputs)
});
export { directory_submit_review_pending_title as "directory.submit.review.pending_title" }